import React, { useMemo, useState } from 'react'
import style from './MetalworkingMachiningCenters.module.css'
import { useTranslation } from 'react-i18next'
import ContactsPopup from '../../../Components/PopUp/ContactPopUp'
import { ScrollArrow } from '../../../Components/ScrollArrow/ScrollArrow'
import Breadcrumbs from '../../../Components/Breadcrumbs/Breadcrumbs'

const MetalworkingMachiningCenters = () => {
  const { t } = useTranslation()
  const [showPopup, setShowPopup] = useState(false)

  const handleOpenPopup = () => setShowPopup(true)
  const handleClosePopup = () => setShowPopup(false)

  const titleText = t('machiningCenters.title')

  const breadcrumbItems = useMemo(
    () => [
      { path: '/', label: t('breadcrumbs.home') },
      { path: '/engineering', label: t('breadcrumbs.engineering') },
      {
        path: '/engineering/metalworking',
        label: t('breadcrumbs.page3'),
      },
    ],
    [t],
  )

  return (
    <div className={style.engineering} id="engineering">
      <div className={`customContainer ${style.engineering_wrap}`}>
        <Breadcrumbs items={breadcrumbItems} />
        <h2 className={style.title}>{titleText}</h2>
        <button onClick={handleOpenPopup} className={style.button}>
          {t('machiningCenters.button')}
        </button>
      </div>
      <ContactsPopup
        show={showPopup}
        onHide={handleClosePopup}
        title={titleText}
      />
      <div className={style.block_arrow}>
        <ScrollArrow />
      </div>
    </div>
  )
}

export default MetalworkingMachiningCenters
